import React, { useEffect, useState } from "react";
import { useAnimatedValue, useAuth, AnimatedBlock } from "react-uicomp";

import CompWrapper from "../../hoc/compWrapper/CompWrapper.hoc";
import Title from "../../common/title/Title.common";
import ImageViewer from "../../common/imageViewer/ImageViewer.common";

// ACTIONs
import { useDispatch, useSelector } from "react-redux";
import { getPhotoGallery } from "../../../actions/Actions";
import { FILE_URL } from "../../../config/Api.config";
import ActivityIndicator from "../../hoc/activityIndicator/ActivityIndicator.hoc";

const GALLERY_IMAGE = [
  "https://images.unsplash.com/photo-1582611738640-a9e1e46bbe45?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80",
  "https://images.unsplash.com/photo-1587963357384-cf239a61ccee?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1102&q=80",
  "https://images.unsplash.com/photo-1582611738640-a9e1e46bbe45?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80",
  "https://images.unsplash.com/photo-1587496713823-c1426efbc4e6?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=967&q=80",
  "https://images.unsplash.com/photo-1582611738640-a9e1e46bbe45?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80",
  "https://images.unsplash.com/photo-1582611738640-a9e1e46bbe45?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80",
];

const GalleryImage = ({ image, setActiveImage, setImageViewerOpen }) => {
  const scale = useAnimatedValue(1);

  return (
    <AnimatedBlock
      onMouseEnter={() => (scale.value = 1.05)}
      onMouseLeave={() => (scale.value = 1)}
      onClick={() => {
        setActiveImage(image);
        setImageViewerOpen(true);
      }}
      className="gallery-item">
      <AnimatedBlock
        style={{
          backgroundImage: `url(${FILE_URL + image})`,
          scale: scale.value,
        }}
        className="gallery-item-image"
      />
    </AnimatedBlock>
  );
};

export const PhotoGalleryPage = () => {
  const { setHeaderTitle } = useAuth();
  const [activeImage, setActiveImage] = useState(null);
  const [imageViewerOpen, setImageViewerOpen] = useState(false);

  const dispatch = useDispatch();
  const { listLoader, list } = useSelector((state) => state.gallery);

  useEffect(() => {
    dispatch(getPhotoGallery());
  }, [getPhotoGallery]);

  useEffect(() => {
    setHeaderTitle("Photo Gallery");
  }, [setHeaderTitle]);

  return (
    <CompWrapper>
      <Title title="Photo Gallery" hide_SeeAll />
      <ActivityIndicator animating={listLoader}>
        <div className="photo-gallery-container">
          <div className="photo-gallery">
            {list?.length ? (
              list.map((item, i) => (
                <div>
                  <GalleryImage
                    key={i}
                    image={item?.thumbnail}
                    setActiveImage={setActiveImage}
                    setImageViewerOpen={setImageViewerOpen}
                  />
                  <h5 style={{ marginTop: 10 }}>{item?.title}</h5>
                </div>
              ))
            ) : (
              <p style={{ textAlign: "center" }}>No Data Available</p>
            )}
          </div>

          <ImageViewer
            open={imageViewerOpen}
            close={setImageViewerOpen}
            activeImage={activeImage}
          />
        </div>
      </ActivityIndicator>
    </CompWrapper>
  );
};
